<div class="col-md-12 col-xs-12" [formGroup]="form">
    <hr>
    <label>{{'assistance-form.experience'| translate}}</label>
    <div formArrayName="myExperience" *ngFor="let item of myExperience.controls; let i = index;">
        <div [formGroupName]="i" class="controls-group">
            <div class="row">
                <div class="col-md-1 col-xs-1">
                    <div class="">
                        <label> </label>
                        <div class="input-group">
                            <button class="btn icon" (click)="removeMyExperienceItem(i)">X</button>
                        </div>
                    </div>
                </div>
                <div class="col-md-5 col-xs-11">
                    <div *ngIf="required[i]">
                        <label mandatory>
                            {{'assistance-form.workPlace'| translate}}
                        </label>
                    </div>
                    <div *ngIf="!required[i]">
                        <label>
                            {{'assistance-form.workPlace'| translate}}
                        </label>
                    </div>
                    <div class="input-group">
                        <input type="text" maxlength="35" class="form-control txt" (change)="change(i)" formControlName="workPlace" id="{{'workPlace' + i}}"
                        />

                    </div>
                    <control-messages [control]="f2[i].controls.workPlace"></control-messages>

                </div>


                <div class="col-md-3 col-xs-12">
                    <div *ngIf="required[i]">
                        <label mandatory>
                            {{'assistance-form.startYear'| translate}}
                        </label>
                    </div>
                    <div *ngIf="!required[i]">
                        <label>
                            {{'assistance-form.startYear'| translate}}
                        </label>
                    </div>
                    <div class="input-group">
                        <input type="text" digitalOnly minlength="4" maxlength="4" class="form-control" (change)="change(i)" formControlName="startYear"
                            id="{{'startYear' + i}}">
                    </div>
                    <control-messages [control]="f2[i].controls.startYear"></control-messages>
                </div>
                <div class="col-md-3 col-xs-12">
                    <div *ngIf="required[i]">
                        <label mandatory>
                            {{'assistance-form.endYear'| translate}}
                        </label>
                    </div>
                    <div *ngIf="!required[i]">
                        <label>
                            {{'assistance-form.endYear'| translate}}
                        </label>
                    </div>
                    <div class="input-group">
                        <input type="text" digitalOnly minlength="4" maxlength="4" class="form-control" (change)="change(i)" formControlName="endYear"
                            id="{{'endYear' + i}}">
                    </div>
                    <control-messages [control]="f2[i].controls.endYear"></control-messages>
                </div>
                <div class="col-md-1 col-xs-1"></div>
                <div class="col-md-5 col-xs-11">
                    <label>
                        {{'assistance-form.job'| translate}}
                    </label>
                    <div class="input-group">
                        <input type="text" maxlength="30" class="form-control txt" (change)="change(i)" formControlName="job" id="{{'job' + i}}"
                        />
                    </div>
                    <control-messages [control]="f2[i].controls.job"></control-messages>
                </div>
                <div class="col-md-5 col-xs-11">
                    <div class="">
                        <div *ngIf="required[i]">
                            <label mandatory>
                                {{'assistance-form.domain'| translate}}
                            </label>
                        </div>
                        <div *ngIf="!required[i]">
                            <label>
                                {{'assistance-form.domain'| translate}}
                            </label>
                        </div>
                        <div class="input-group">
                            <select class="form-control" (change)="change(i)" formControlName="domain" id="{{'domain' + i}}">
                                <option *ngFor="let item of baseService.ThumTaasuka" value="{{item.KOD}}">{{item.TEUR}}</option>
                            </select>
                        </div>
                        <control-messages [control]="f2[i].controls.domain"></control-messages>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row controls-group">
        <div class="col-md-12 col-xs-12">
            <div class="input-group">
                <button type="button" class="btn small" (click)="addMyExperienceItem()">{{'add'| translate}}</button>
            </div>
        </div>
    </div>
</div>